
















import Vue from 'vue'
import tippy, { Props } from 'tippy.js'

export default Vue.extend({
  props: {
    placement: {
      type: String as () => Props['placement'],
      required: false,
      default: 'auto'
    },
    bodyTheme: {
      type: String,
      default: ''
    },
    maxWidth: {
      type: Number,
      required: false,
      default: undefined
    },
    interactive: {
      type: Boolean,
      default: false
    }
  },
  mounted() {
    const tooltipEl = this.$refs.tooltip as HTMLElement
    const tooltipContentEl = this.$refs.tooltipContent as HTMLElement

    tippy(tooltipEl, {
      content: tooltipContentEl,
      trigger: 'mouseenter focus',
      placement: this.placement,
      allowHTML: true,
      theme: this.bodyTheme ?? 'sw-Tooltip',
      maxWidth: this.maxWidth,
      interactive: this.interactive
    })
  }
})
